var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from 'styled-components';
import { StatusIndicator } from '../../StatusIndicator';
import { SkillStatus } from '../../../constants/statuses';
import { ExpandRowButton } from '../ExpandRowButton';
import { checkIfStudentRow } from '../tableConfig';
var ScCell = styled.div.withConfig({ displayName: "ScCell", componentId: "sc-ii2qm4" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var StudentSkillCell = function (_a) {
    var _b;
    var skillId = _a.skillId, onSkillClick = _a.onSkillClick, cellProps = __rest(_a, ["skillId", "onSkillClick"]);
    var row = cellProps.row;
    var skillData = React.useMemo(function () {
        var _a, _b;
        return (_b = (_a = row.original) === null || _a === void 0 ? void 0 : _a.skills) === null || _b === void 0 ? void 0 : _b.find(function (el) { return el.skillId === skillId; });
    }, [(_b = row.original) === null || _b === void 0 ? void 0 : _b.skills, skillId]);
    var skillStatus = (skillData === null || skillData === void 0 ? void 0 : skillData.status) || SkillStatus.NoData;
    var handleSkillClick = React.useCallback(function () {
        onSkillClick === null || onSkillClick === void 0 ? void 0 : onSkillClick();
        row.setState({ status: skillData === null || skillData === void 0 ? void 0 : skillData.status });
    }, [row, skillData === null || skillData === void 0 ? void 0 : skillData.status]);
    if (!checkIfStudentRow(row.original))
        return null;
    return (_jsxs(ScCell, __assign({ "data-testid": skillId, "data-skill-status": skillStatus }, { children: [_jsx(StatusIndicator, { status: skillStatus, inProgress: skillData === null || skillData === void 0 ? void 0 : skillData.inProgress, progressPosition: 'right' }, void 0), _jsx(ExpandRowButton, __assign({}, cellProps, { onClick: handleSkillClick }), void 0)] }), void 0));
};
export { StudentSkillCell };
var templateObject_1;
